jQuery('#access-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
  dots:false,
   autoplay: true,
   autoplayTimeout: 10000,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1280:{
            items:3
        }
    }
});
jQuery('#logo-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
   dots:false,
  navText: [
        
      "<img src='https://cdn.shopify.com/s/files/1/0509/0164/7509/files/Vector_62.png?v=1695626035'>","<img src='https://cdn.shopify.com/s/files/1/0509/0164/7509/files/Vector_61.png?v=1695626035'>",
    ],
    responsive:{
        0:{
            items:2
        },
        600:{
            items:3
        },
        1024 :{
            items:4
        },
        1280:{
            items:6
        }
    }
})